module.exports = __webpack_public_path__ + "assets/img/case6.7154f01f.png";